/* Panier : retrait et quantités fiables (Numerigram, 16/10/2026).
   Le thème désigne une ligne du panier par son RANG (« ligne 2 »). Si le panier a changé
   ailleurs (autre onglet, emballage cadeau ajouté ou retiré automatiquement), ce rang ne
   correspond plus : la corbeille ne supprime rien et affiche à tort
   « Nous n'avons que 1 articles en stock ! ».
   Ici, avant chaque changement, on vérifie le rang de la ligne dans le panier réel :
   - rang correct : le thème fait son travail habituel ;
   - rang décalé : on modifie la ligne par sa CLÉ, puis on réaffiche le panier ;
   - ligne déjà retirée ailleurs : on réaffiche simplement le panier. */
/* Emballage cadeau orphelin (16/10/2026).
   assets/sdo-emballage.js ne resynchronise le panier que dans l'onglet où un emballage a été
   choisi (mémoire de session propre à chaque onglet). Dans un autre onglet, retirer le produit
   laissait la ligne « Emballage cadeau » seule et invisible : panier « 1 article » à 0,00 €,
   et « Commander » renvoyait à l'accueil. Si le panier affiché contient un emballage, on active
   cette mémoire ; si elle ne l'était pas, on relance une synchronisation (mise à jour vide du
   panier, que sdo-emballage.js surveille). */
(function () {
  function emballageAffiche() {
    return !!document.querySelector('.cart__item a[href*="/products/emballage-cadeau"], .cart__item [data-sdo-emb-ligne].est-emballe');
  }
  function verifier() {
    if (!emballageAffiche()) return;
    var deja = true;
    try { deja = sessionStorage.getItem('sdo-emb-actif') === '1'; sessionStorage.setItem('sdo-emb-actif', '1'); } catch (e) { return; }
    if (deja) return;
    var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(racine + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: '{}' }).catch(function () {});
  }
  if (document.readyState === 'complete') setTimeout(verifier, 300);
  else window.addEventListener('load', function () { setTimeout(verifier, 300); });
})();

(function () {
  if (!window.customElements) return;
  customElements.whenDefined('cart-items').then(function () {
    var Classe = customElements.get('cart-items');
    if (!Classe || Classe.prototype.__sdoCle) return;
    var origine = Classe.prototype.updateQuantity;
    Classe.prototype.__sdoCle = true;
    Classe.prototype.updateQuantity = function (line, quantity, name, clear) {
      var self = this, args = arguments;
      if (clear) return origine.apply(self, args);
      var ligne = self.querySelector('#CartItem-' + line) || self.querySelector('#CartDrawer-Item-' + line);
      var cle = ligne && ligne.getAttribute('data-key');
      if (!cle) return origine.apply(self, args);
      var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(racine + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var rang = -1;
          (cart.items || []).forEach(function (it, i) { if (rang < 0 && it.key === cle) rang = i + 1; });
          if (rang === parseInt(line, 10)) return origine.apply(self, args);
          if (typeof self.enableLoading === 'function') self.enableLoading(line);
          var suite = rang < 0
            ? Promise.resolve(cart)
            : fetch(racine + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: cle, quantity: parseInt(quantity, 10) || 0 })
              }).then(function (r) { return r.json(); });
          return suite.catch(function () { return null; }).then(function (etat) {
            /* Panier vide : même état « vide » que le thème (page et tiroir) */
            if (etat && typeof etat.item_count === 'number') {
              var vide = etat.item_count === 0;
              self.classList.toggle('is-empty', vide);
              var tiroir = document.querySelector('cart-drawer');
              if (tiroir) tiroir.classList.toggle('is-empty', vide);
              var page = document.getElementById('main-cart');
              if (page) page.classList.toggle('is-empty', vide);
              var videTxt = document.querySelector('.empty-page-content');
              if (videTxt) videTxt.classList.toggle('hide', !vide);
            }
            return self.onCartUpdate(etat ? etat.item_count : undefined, parseInt(quantity, 10) || 0);
          });
        })
        .catch(function () { return origine.apply(self, args); });
    };
  });
})();
